import { useState } from "react"
import * as Icons from "@nova/component-icons"
import { IconButton } from "@nova/component-btn"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"

type CommentImagesModalProps = {
    urls: string[]
    startIndex: number
    close: () => void
}

export const CommentImagesModal = ({ urls, startIndex, close }: CommentImagesModalProps) => {
    const [index, setIndex] = useState(startIndex)

    const step = (delta: number) =>
        setIndex((current) => (current + delta + urls.length) % urls.length)

    return (
        <HighPriorityNovaModalContainer title="" closeModal={close} className="max-w-4xl">
            <div className="relative flex items-center justify-center">
                {urls.length > 1 && (
                    <IconButton
                        onClick={() => step(-1)}
                        className="absolute left-2 flex size-10 items-center justify-center rounded-full bg-gray-800/80 text-gray-100 hover:text-white"
                    >
                        <Icons.SmallIcon Icon={Icons.ArrowLeft} className="size-6" />
                    </IconButton>
                )}
                <img
                    src={urls[index]}
                    alt=""
                    className="max-h-[80vh] max-w-full rounded-lg object-contain"
                />
                {urls.length > 1 && (
                    <IconButton
                        onClick={() => step(1)}
                        className="absolute right-2 flex size-10 items-center justify-center rounded-full bg-gray-800/80 text-gray-100 hover:text-white"
                    >
                        <Icons.SmallIcon Icon={Icons.ArrowRight} className="size-6" />
                    </IconButton>
                )}
            </div>
        </HighPriorityNovaModalContainer>
    )
}
